import { useEffect } from 'react';
import Toolbar from '@plone/volto/components/manage/Toolbar/Toolbar';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { useClient } from '@plone/volto/hooks';
import { getContactInfo } from 'govbr.frontend.institucional/actions';
import { Contact } from 'govbr.frontend.institucional/components';
import govMessages from 'govbr.frontend.institucional/messages/contact_form';
import { defineMessages, useIntl } from 'react-intl';
import { Portal } from 'react-portal';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

import styles from './ContactForm.module.less';

const messages = defineMessages({
  contactUs: {
    id: 'Contact us',
    defaultMessage: 'Contact us',
  },
  serviceChannels: {
    id: 'Service channels',
    defaultMessage: 'Service channels',
  },
  contactForm: {
    id: 'Contact form',
    defaultMessage: 'Contact form',
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
});

const ContactFormComponent = ({ history }) => {
  const { pathname } = useLocation();
  const intl = useIntl();
  const isClient = useClient();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getContactInfo());
  }, [dispatch]);

  const contactInfoState = useSelector((state) => state.contact_info);
  const siteProperties = useSelector((state) => state.site_properties.data);

  if (
    contactInfoState.loading ||
    (!contactInfoState.loaded && !contactInfoState.error)
  ) {
    return <div className="loading" />;
  }

  if (!contactInfoState.loading && contactInfoState.error) {
    history.replaceState('/');
    return null;
  }

  const { phone_number, other_informations, email } = contactInfoState.data;

  if (
    contactInfoState.loaded &&
    !phone_number &&
    !other_informations &&
    !email
  ) {
    history.replace('/');
    return null;
  }

  return (
    <div className="ui container">
      <h1 className="documentFirstHeading">
        {intl.formatMessage(govMessages.contactUs)}
      </h1>
      <span className="br-divider mt-2 mb-5"></span>
      <div id="contact-form">
        <Helmet title={intl.formatMessage(messages.serviceChannels)} />
        <BodyClass className="gov-public" />
        <div className={styles.cols}>
          <Contact.Info
            contact-info={contactInfoState.data}
            site-name={siteProperties.site_title}
          />
          {email ? (
            <Contact.Form to={email} site-name={siteProperties.site_title} />
          ) : null}
        </div>
        {isClient && (
          <Portal node={document.getElementById('toolbar')}>
            <Toolbar
              pathname={pathname}
              hideDefaultViewButtons
              inner={
                <Link to={`${getBaseUrl(pathname)}`} className="item">
                  <Icon
                    name="arrow left"
                    size="big"
                    color="blue"
                    title={intl.formatMessage(messages.back)}
                  />
                </Link>
              }
            />
          </Portal>
        )}
      </div>
    </div>
  );
};

export default withRouter(ContactFormComponent);
